import React from 'react';
import styled from 'styled-components';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { palette } from 'theme';
import { connect } from 'react-redux';
import Divider from '@material-ui/core/Divider';
import { Typography } from '@material-ui/core';
import DistributorModal from './DistributorModal';
import Container from 'components/Container';
import { getMenuContentStackData } from 'features/registration/actions';

const DistributorBarWrapper = styled.div`
  height: 42px;
  background-color: ${'#66ff66'};
  display: flex;
  align-items: center;
  overflow: visible;
  position: relative;
  z-index: 1300;
`;

const FlexNav = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
  overflow: visible;
`;

const VerticalDivider = styled(Divider)`
  width: 1px;
  height: 24px;
  margin: 0 8px;
`;

const DistributorBar = () => {
  return (
    <DistributorBarWrapper>
      <MuiThemeProvider theme={palette}>
        <Container>
          <FlexNav>
            <Typography>
              We've detected you're in a distributor managed country; to better
              assist you, please reach out to your friendly, local distribution
              representative for all orders!
            </Typography>
            <VerticalDivider />
            <DistributorModal displayText="Learn More" />
          </FlexNav>
        </Container>
      </MuiThemeProvider>
    </DistributorBarWrapper>
  );
};

export default connect(
  state => ({
    stack: state.navigation.stack,
    menuStack: state.registration.content_stack.menu,
    user: state.buckaneer.user
  }),
  { getMenuContentStackData }
)(DistributorBar);
